module.exports = __webpack_public_path__ + "img/LOGO_TAUR-WHITE-TRANSPARENT.0640665d.png";